import {
    Swiper,
    Navigation,
    EffectFade
} from 'swiper/js/swiper.esm.js';
import 'swiper/swiper.scss';
import  'swiper/src/components/effect-fade/effect-fade.scss'
import './interval';

Swiper.use([Navigation, EffectFade]);


export default class Lightbox {
    galleries = [];
    slider;
    modal;

    constructor(triggerSelector) {
        const items = document.querySelectorAll(triggerSelector);

        if (items && items.length) {
            this.create();
            items.forEach((item, key) => {
                if (!this.galleries[item.dataset.gallery]) {
                    this.galleries[item.dataset.gallery] = [];
                }
				this.galleries[item.dataset.gallery].push(item.dataset);
				const index = this.galleries[item.dataset.gallery].length - 1;
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.show(item.dataset.gallery, index);
                })
            })

        }
    }

    create() {
        this.wrapper = document.createElement('div');
		this.wrapper.classList.add('swiper-wrapper');

		const prevBtn = document.createElement('div');
		prevBtn.classList.add('swiper-button-prev');

		const nextBtn = document.createElement('div');
		nextBtn.classList.add('swiper-button-next');

        const container = document.createElement('div');
        container.classList.add('swiper-container', 'sw-lighbox-slider');
		container.append(this.wrapper, prevBtn, nextBtn);
		
		const closeBtn = document.createElement('button');
		closeBtn.classList.add('sw-lightbox-close');
		closeBtn.addEventListener('click', (e)=>{
			this.close();
		})
		closeBtn.innerHTML = '<span class="sr-only">Close</spna>';

        this.modal = document.createElement('div');
        this.modal.classList.add('sw-lightbox');
        this.modal.append(container, closeBtn);

        document.body.append(this.modal);
        this.slider = new Swiper(container, {
            speed: 1200,
            spaceBetween: 0,
            slidesPerView: 1,
			preloadImages: true,
			effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        })
    }

    show(gallery, index) {
        this.galleries[gallery].forEach(item => {
            const slide = document.createElement('div');
            slide.classList.add('swiper-slide');

            const slideImg = document.createElement('img');
            slideImg.classList.add('swiper-slide-img');
            slideImg.setAttribute('src', item.lightbox);
            slide.append(slideImg);


            const slideInfo = document.createElement('div');
            slideInfo.classList.add('swiper-slide-info', 'container');
            slide.append(slideInfo);

            if (item.roomType) {
                const slideRoomType = document.createElement('p');
                slideRoomType.classList.add('slide-room-type');
                slideRoomType.innerHTML = '<span class="typed">Room type</span><span class="big-letter"><span>' + item.roomType + '</span></span>';
                slideInfo.append(slideRoomType);
            }
            if (item.title) {
                const slideTitle = document.createElement('p');
                slideTitle.classList.add('slide-title');
                slideTitle.innerHTML = '<span class="typed">' + item.title + '</span>';
                slideInfo.append(slideTitle);
            }


            this.slider.appendSlide(slide);

		})
		this.slider.slideTo(index, 0);
		document.body.classList.add('overflow-hidden')
		this.modal.classList.add('open');
		this.slider.update();
	
	}
	
	close(){
		
		this.modal.classList.remove('open');
		requestTimeout(() =>{
			document.body.classList.remove('overflow-hidden')
			this.slider.removeAllSlides();
		}, 300)
		
	}


}